import { addHours, addDays, addWeeks, addMonths, addYears, differenceInYears, differenceInMonths, differenceInCalendarDays, differenceInQuarters, differenceInWeeks, differenceInHours, startOfWeek, format, getHours, endOfHour, startOfHour, } from "date-fns";
import { locate, locateID } from "@xbs/lib-dom";
import getMinutes from "date-fns/getMinutes";
import setMinutes from "date-fns/setMinutes";
const diff = {
    year: differenceInYears,
    quarter: differenceInQuarters,
    month: differenceInMonths,
    week: differenceInWeeks,
    day: differenceInCalendarDays,
    hour: differenceInHours,
};
const add = {
    year: addYears,
    month: addMonths,
    week: addWeeks,
    day: addDays,
    hour: addHours,
};
export function getDiffer(unit) {
    return diff[unit];
}
export function getAdder(unit) {
    return add[unit];
}
export function getUnitStart(unit, start, weekStartsOn = 1) {
    let t;
    switch (unit) {
        case "month":
            return new Date(start.getFullYear(), start.getMonth(), 1);
        case "year":
            return new Date(start.getFullYear(), 0, 1);
        case "week":
            return startOfWeek(start, { weekStartsOn });
        case "day":
            t = new Date(start.getFullYear(), start.getMonth(), start.getDate());
            t.setHours(0, 0, 0, 0);
            return t;
        case "hour":
            t = new Date(start.getFullYear(), start.getMonth(), start.getDate());
            t.setHours(0, 0, 0, 0);
            return t;
        default:
            return new Date(start);
    }
}
export function updateDateByPos(date, e, topFactor) {
    const elements = document.elementsFromPoint(e.clientX, e.clientY);
    let id = "";
    let cell;
    for (let i = 0; i < elements.length; i++) {
        id = locateID(elements[i], "data-cell");
        if (id) {
            cell = locate(elements[i], "data-cell");
            break;
        }
    }
    if (!cell)
        return date;
    const { top, height } = cell.getBoundingClientRect();
    const [day, time] = `${id}`.split(":");
    const diff = differenceInCalendarDays(new Date(+day), date);
    const newDate = addDays(date, diff);
    if (time) {
        const minutePx = height / 60;
        const moveInfo = topFactor ? topFactor - top : 0;
        const minute = moveInfo / minutePx;
        newDate.setHours(0, 0, 0);
        newDate.setMinutes(+time + minute);
    }
    return newDate;
}
export function roundTimeByStep(date, step) {
    if (!step)
        return date;
    const minutes = getMinutes(date);
    return setMinutes(date, Math.round(minutes / step) * step);
}
export function getTimeFormat(date, locale, showAM = true) {
    const _ = locale.getGroup("scheduler");
    const isAM = locale.getRaw().calendar.timeFormat === 12;
    const hourFormat = _("hourFormat");
    const minuteFormat = _("minuteFormat");
    const start_minutes = getMinutes(date);
    return `${hourFormat}${start_minutes || !isAM ? `:${minuteFormat}` : ""}${showAM && isAM ? " a" : ""}`;
}
export function getRangeTimeString(event, locale) {
    const { dateFnsLocale, calendar } = locale.getRaw();
    const _dates = dateFnsLocale;
    const isAm = calendar.timeFormat === 12;
    const { start_date, end_date } = event;
    let start_format = getTimeFormat(start_date, locale, false);
    const end_format = getTimeFormat(end_date, locale);
    const start_hour = getHours(start_date);
    const end_hour = getHours(end_date);
    if (isAm &&
        ((start_hour > 12 && end_hour <= 12) ||
            (start_hour < 12 && end_hour >= 12))) {
        start_format += ` a`;
    }
    return `${format(start_date, start_format, { locale: _dates })} - ${format(end_date, end_format, { locale: _dates })}`;
}
export function calculateTimeLinePosition(timeScale) {
    const now = new Date().valueOf();
    const start = startOfHour(timeScale[0].label).valueOf();
    const end = endOfHour(timeScale[timeScale.length - 1].label).valueOf();
    if (now < start || now > end)
        return;
    const endScale = end - start;
    return `${((now - start) * 100) / endScale}%`;
}
export { format };
//# sourceMappingURL=time.js.map